import { entriesFromSocialObject } from '../../utils/socialLinks';

/**
 * Inline row of external link chips (salon or branch manager socials).
 */
export default function SocialLinksRow({ social, className = '', size = 'default' }) {
  const items = entriesFromSocialObject(social);
  if (items.length === 0) return null;

  const isSmall = size === 'small';
  return (
    <div
      className={`salon-browser-social-row ${className}`.trim()}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: isSmall ? '0.35rem' : '0.5rem',
        marginTop: isSmall ? '0.35rem' : '0.5rem',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {items.map(({ key, label, url }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="salon-browser-social-chip"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: isSmall ? '0.2rem 0.55rem' : '0.35rem 0.65rem',
            borderRadius: '6px',
            background: 'rgba(0, 100, 178, 0.08)',
            border: '1px solid var(--border)',
            color: '#fff',
            fontFamily: "'Oswald', sans-serif",
            fontSize: isSmall ? '0.65rem' : '0.72rem',
            fontWeight: 700,
            letterSpacing: '0.05em',
            textDecoration: 'none',
            textTransform: 'uppercase',
          }}
        >
          {label}
        </a>
      ))}
    </div>
  );
}
